import { PlusCircleOutlined } from '@ant-design/icons';
import { gql, useMutation } from '@apollo/client';
import { Button, Form, Input, Modal, Typography, notification } from 'antd';
import React, { useCallback, useState } from 'react';
import { generateUuid } from '@aims/shared/shared/utils';
import LanguageForm from './LanguageForm';

export const upsertSimpleListItemForAdminMutation = gql`
  mutation AddLanguageForAdmin($name: String!, $item: SimpleListItemInput!) {
    upsertSimpleListItemForAdmin(name: $name, item: $item)
  }
`;

const { Title, Text } = Typography;

function AddLanguageModal({ onFinish }) {
  const [editing, setEditing] = useState();
  const handleEdit = useCallback(() => setEditing(true), []);
  const onDone = useCallback(() => setEditing(false), []);
  const onCancel = useCallback(() => setEditing(false), []);

  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);
  const [addLanguage] = useMutation(upsertSimpleListItemForAdminMutation);

  const handleFinish = useCallback(
    async (_values) => {
      setSaving(true);
      try {
        const { key, color } = _values;
        await addLanguage({
          variables: {
            name: 'tr-language',
            item: {
              _id: generateUuid(),
              key: key,
              content: JSON.stringify({}),
            },
          },
        });
        onFinish();
        notification.success({
          message: 'Success',
          description: 'Language saved successfully',
        });
        onDone();
      } catch (err) {
        console.error(err);
        notification.error({
          message: 'Error',
          description: 'We apologize.  An error occurred',
        });
      }
      setSaving(false);
    },
    [addLanguage, onDone, onFinish],
  );
  return (
    <>
      <Modal
        open={editing}
        closable={false}
        destroyOnClose={true}
        maskClosable
        footer={null}
        onCancel={onCancel}
      >
        <Title level={3} style={{ marginTop: 8 }}>
          Create Language
        </Title>
        <LanguageForm
          form={form}
          handleFinish={handleFinish}
          saving={saving}
          onCancel={onCancel}
        />
      </Modal>
      <Button
        type="link"
        size="large"
        icon={<PlusCircleOutlined />}
        onClick={handleEdit}
      >
        Add a Language
      </Button>
    </>
  );
}

export default AddLanguageModal;
